import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import { NineCellLoading } from 'react-loadingg';
import getSupportTickets from "../../services/getSupportTickets";
import translateString from '../../utils/Locales';
import '../landingPage/style.css';
import addSupportTicket from "../../services/addSupportTicket";
import ReactHtmlParser from 'react-html-parser';
import followUpSupportTicket from "../../services/followUpSupportTicket";
import sendMail from "../../services/sendMainEmail";
import Utils from "../../utils/utils";

let t = translateString;
const qs = require('querystring');

export default class TicketDetails extends React.Component {

  constructor(props){
    super (props)
  
    this.state = {
      newTicket: false,
      isLoading: true,
      newTicket: false,
      text: '',
      subject: '',
      ticketId: '',
    };

  }
  
  async load() {

    this.setState({ isLoading: true, newTicket: false });
    
    const parsed = qs.parse(window.location.hash);
    const ticketID = parsed['#/app/ticketDetails?ticket'];
    this.setState({ ticketId: ticketID });

    await this.reloadTickets(ticketID);
  }

  async reloadTickets(id) {
    this.setState({ isLoading: true, newTicket: false });
    if (id === null || id === undefined || id === '') {
      this.tickets = [];
      this.setState({ newTicket: true, isLoading: false });
    } else {
      const cookies = new Cookies();
      const username = cookies.get('username', { path: '/' });
      const token = cookies.get('token', { path: '/' });

      this.tickets = [];
      this.tickets = await getSupportTickets(username, token);
      this.tickets = this.tickets.filter((ticket) => ((ticket.id === id || ticket.id_thread === id) && ticket.username === username && ticket.db_name === cookies.get('db', { path: '/' }) ));
      this.setState({ isLoading: false });
    }
  }

  async componentDidMount(){
      await this.load();
  }

  async send() {

    if (this.state.text.trim() !== '') {
        this.setState({ isLoading: true });

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' }); 

        if(this.state.newTicket) {
          
          if (this.state.subject.trim() === '') {
              Utils.showInfo(t('aggiungi_ogg'));
              this.setState({ isLoading: false });
              return;
          }
    
          let res = await addSupportTicket(username, token, 'user', this.state.subject, this.state.text.replace(/\n/g, '<br/>'));
          if(res !== null && res.result === 'ok') {
            await sendMail('no-reply@Hdemia.cloud', 'Hdemia Support', 'Nuova richiesta di assistenza inserita da: ' + cookies.get('db', { path: '/' }), 'Ciao,<br/>verifica la nuova richiesta nel portale di assistenza.');
            this.setState({ ticketId: res.insert_id, text: '', isLoading: false });
            await this.reloadTickets(res.insert_id);
          } else {
            this.setState({ isLoading: false });
            Utils.showError(t('errore_imprevisto'));
          }
        } else {
          let res = await followUpSupportTicket(username, token, this.state.ticketId, 'user', this.tickets[0].subject, this.state.text.replace(/\n/g, '<br/>'));
          if(res !== null && res.result === 'ok') {
            await sendMail('no-reply@Hdemia.cloud', 'Hdemia Support', 'Nuova risposta al ticket di: ' + cookies.get('db', { path: '/' }), 'Ciao,<br/>verifica la nuova risposta nel portale di assistenza.');
            this.setState({ text: '', isLoading: false });
            await this.reloadTickets(this.state.ticketId);
          } else {
            this.setState({ isLoading: false });
            Utils.showError(t('errore_imprevisto'));
          }
        }
    }
  }

  render () {

    var current = 'user';

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />
    if (!this.state.newTicket && this.tickets.length === 0) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />;

    return (
      <div>
          <PageTitle title={this.state.newTicket ? t('tuo_ticket') : this.tickets[0].subject} />

          <div style={{ position: 'absolute', bottom: (this.tickets.length !== 0 && this.tickets[0].solved === '0') ? 160 : 10, right: 0, left: 250, top: 180, paddingTop: 10, paddingBottom: 10, overflowX: 'hidden', overflowY: 'scroll' }}>
            { this.tickets.map((ticket) => {
             
              var curr = current;
              current = ticket.sentFrom;

              if (ticket.sentFrom === 'admin') {
                return(
                  <div key={ticket.id} style={{ ...ticketView, marginLeft: '5%', marginTop: curr !== current ? 30 : 0, marginRight: '25%', position: 'relative' }}>
                    <p>{ReactHtmlParser(ticket.message)}</p>
                    <p style={{ position: 'absolute', bottom: -5, right: 10, color: 'lightgrey' }}>{ticket.creation_date}</p>
                  </div>
                );
              } else {
                return (
                  <div key={ticket.id} style={{ ...ticketView, marginLeft: '25%', marginRight: '5%', marginTop: curr !== current ? 30 : 0, position: 'relative' }}>
                    <p>{ReactHtmlParser(ticket.message)}</p>
                    <p style={{ position: 'absolute', bottom: -5, right: 10, color: 'lightgrey' }}>{ticket.creation_date}</p>
                  </div>
                );
              }
              
            })}
          </div>
          { this.state.newTicket && (
            <textarea value={this.state.subject} placeholder={t('inserisci_oggetto')} style={{ position: 'absolute', bottom: 120, right: 100, left: 250, height: 30, border: 0, borderRadius: '10px', boxShadow: '0px 2px 10px lightgrey', paddingLeft: 30, paddingRight: 30, paddingTop: 5, paddingBottom: 5, whiteSpace: 'pre', resize: 'none' }} onChange={(e) => { this.setState({ subject: e.target.value }); }}></textarea>
          )}
          { (!this.state.newTicket && this.tickets[0].solved === '0') && (
            <p style={{ position: 'absolute', bottom: 100, right: 100, left: 255, color: 'darkgrey' }}>{t('non_chat')}</p>
          )}
          { (this.tickets.length === 0 || (this.tickets.length !== 0 && this.tickets[0].solved === '0')) && <div>
            <textarea value={this.state.text} placeholder={t('inserisci_ticket')} style={{ position: 'absolute', bottom: 10, right: 100, left: 250, height: 100, border: 0, borderRadius: '10px', boxShadow: '0px 2px 10px lightgrey', paddingLeft: 30, paddingRight: 30, paddingTop: 15, paddingBottom: 15, whiteSpace: 'pre', resize: 'none' }} onChange={(e) => { this.setState({ text: e.target.value }); }}></textarea>
            <div className="btn btn-primary" onClick={this.send.bind(this)} style={{ position: 'absolute', right: 10, width: 80, bottom: 40 }}>{t('invia')}</div>
          </div> }
      </div>
    );
  }
}

const ticketView = {
    width: '70%', 
    backgroundColor: 'white', 
    boxShadow: '0px 2px 10px lightgrey', 
    borderRadius: '10px', 
    padding: 30,
    marginBottom: 5,
};  

